module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length) ? _c('div', {
    staticClass: "slider"
  }, [_c('sss', {
    ref: "slider",
    staticClass: "inner",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "pages": _vm.pages,
      "sliderinit": _vm.sliderConfig
    },
    on: {
      "slide": _vm.onSlide,
      "click": _vm.sliderClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.currentTitle))])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50601f12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = 99
// module chunks = 1